<template>
  <div class="emoticon-list-wrap">
    <ul class="emoticon-list">
      <li v-for="(emoticon,index) in emoticons " :key="index" class="emoticon-item">
        <div class="emoticon-outline">
          <img :src="baseUrl + emoticon.file_path" @click="appendEmoticon(emoticon)" class="emoticon" v-if="emoticon.file_path">
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  name: "Emoticon",
  data() {
    return {
      MAX_COLUMN_CNT : 4,
      baseUrl : '',
      click_once: false
    }
  },
  created() {
    const emptyEmoticon = {
      num: 0 ,
      file_path: ''
    }
    this.baseUrl = process.env.VUE_APP_MOBIGO_URL

    // 이모티콘 영역 맞추기 위해서, 행 별로 4건씩 노출 하기 위해
    if( this.emoticons.length % this.MAX_COLUMN_CNT !== 0){
      const length = this.emoticons.length
      const requireItemCount = length % this.MAX_COLUMN_CNT;
      if ( requireItemCount === 0 ){
        return
      }
      const addItemCount = this.MAX_COLUMN_CNT - requireItemCount
      for( let i = 0 ; i < addItemCount; i++ ){
        this.emoticons.push(emptyEmoticon)
      }
      console.log(this.emoticons.length)
    }
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
  },
  computed : {
    ...mapState(['emoticons']),
  },
  methods : {
    callbackBackKey () {
      this.slidePanelClose();
    },
    appendEmoticon (emoticon){
      // 연달아 클릭시 중복처리되는 경우 발생. 원치않는 history back 발생 방지.
      if( !this.click_once ){
        this.click_once = true
        this.$emit("closePanel", emoticon)
      }
    }
  }
}
</script>

<style scoped>
.emoticon-list-wrap {
  background: #eee;
}
.emoticon-list {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}
.emoticon-item {
  flex: 1 1 25%;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fff;
}
.emoticon-outline{
  padding: 15px;
}
.emoticon {
  width: 100%;
}

</style>